"use client";

import {
  SessionProvider as NextAuthSessionProvider,
  type SessionProviderProps,
} from "next-auth/react";

export default function SessionProvider(props: SessionProviderProps) {
  return (
    <NextAuthSessionProvider
      {...props}
      refetchInterval={60}
      refetchOnWindowFocus
      refetchWhenOffline={false}
    />
  );
}
